var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0C1.51826 0 1.82348 0.122917 2.04853 0.341709C2.27357 0.560501 2.4 0.857247 2.4 1.16667V11.1147L19.8577 0.955938C20.261 0.717473 20.7227 0.588688 21.1946 0.583044C21.6665 0.5774 22.1314 0.695104 22.5405 0.923854C23.4405 1.41969 24 2.38219 24 3.42708V24.5729C24 25.6207 23.4405 26.5803 22.5405 27.0761C22.1313 27.3047 21.6664 27.4222 21.1945 27.4165C20.7226 27.4107 20.2609 27.2818 19.8577 27.0433L2.4 16.8853V26.8333C2.4 27.1428 2.27357 27.4395 2.04853 27.6583C1.82348 27.8771 1.51826 28 1.2 28C0.88174 28 0.576516 27.8771 0.351472 27.6583C0.126428 27.4395 0 27.1428 0 26.8333V1.16667C0 0.857247 0.126428 0.560501 0.351472 0.341709C0.576516 0.122917 0.88174 0 1.2 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipPrevious);
export default __webpack_public_path__ + "static/media/skip_previous.7326b154fcb68e5524d9026bf4cb672c.svg";
export { ForwardRef as ReactComponent };